import { Card, CardContent, Grid, Divider, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FiscalContent from './FiscalContent';

const FiscalStatus = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const title = t('fiscal-detail.dashboard.title');

  return (
    <Card
      data-guide="dashboard-fiscal-import-card"
      sx={{
        borderRadius: 3,
        boxShadow: 2,
        background: theme.palette.background.paper,
      }}
    >
      <CardContent>
        <Typography variant="subtitle2">{title}</Typography>
        <Divider />
        <FiscalContent />
      </CardContent>
    </Card>
  );
};

export default FiscalStatus;
